import React from 'react';
import { APIAction } from '../../../order-menu/api-action/api-action';
import ActionCard from '../../cards/actionCard/actionCard';
import { useTranslation } from 'react-i18next';
import TransferModal from '../../misc/transfer-modal/transferModal';
import Message from '../../../jo-components/misc/message/message';
import './actionsBlock.css';

export default function ActionsBlock({config, onSubmit = () => {}}) {

    const [showRefuseModal, setShowRefuseModal] = React.useState(false);

    const { t } = useTranslation();
    const {title, subtitle, actions = []} = config?.actions_block || {};

    const EXCLUDED_ICON_TYPES = new Set([
        'ValidateTicketTransferStep',
        'RefuseTicketTransferStep',
        'DeleteTicketResaleStep'
    ]);

    const actionMapping = React.useMemo(() => ({
        ValidateTicketTransferStep: { icon: 'check' },
        RefuseTicketTransferStep: { icon: 'redCross' },
        DeleteTicketResaleStep: { icon: 'redCross' },
        UpdateTicketResaleStep: { icon: 'edit' },
        DownloadTicketStep: { icon: 'download' },
        TicketUpdateFormStep: { icon: 'edit' },
        RateChangeStep: { icon: 'refresh' },
        CashlessRedirectStep: { icon: 'walletPay' },
        DownloadAppFragolabsStep: { icon: 'mobile' },
        RefundStep: { icon: 'rotate' },
        TicketResaleStep: { icon: 'cart' },
        ResaleMenuStep: { icon: 'cart' },
        ModerationFormUpdateStep: { icon: 'edit' },
        TicketTransferStep: { icon: 'paperPlane' },
        CancelTicketTransferStep: { icon: 'paperPlane' },
        External_link: { icon: 'externalLink' },
    }), []);

    const handleActionClick = (actionType) => {
        onSubmit({ data: { action: actionType } });
    };

    const refuseTicketAction = React.useMemo(() => {
        return actions.find(action => action.type === 'RefuseTicketTransferStep');
    }, [actions]);

    const handleClick = React.useCallback((action) => {
        const type = action.type;

        // External link
        if (type === 'External_link') {
            const url = action?.config?.url;
            if (url) window.open(url, '_blank', 'noopener,noreferrer');
            return;
        }

        // Actions with metadata.url (DownloadTicketStep / DownloadAppFragolabsStep)
        if (type === 'DownloadTicketStep' || type === 'DownloadAppFragolabsStep') {
            const metadata = action?.metadata || {};
            if (metadata.url) {
                window.open(metadata.url, '_blank', 'noopener,noreferrer');
                return;
            }
            handleActionClick(type);
            return;
        }

        // Special modal (RefuseTicketTransferStep)
        if (type === 'RefuseTicketTransferStep') {
            setShowRefuseModal(true);
            return;
        }

        // Default behavior
        handleActionClick(type);
    }, [handleActionClick]);

    return (
        <>
            {showRefuseModal && (
                <TransferModal 
                    open={showRefuseModal} 
                    title={refuseTicketAction.metadata?.modal?.title} 
                    body={refuseTicketAction.metadata?.modal?.body} 
                    ctaLabel={t('widget.resale.breakdown.cta-confirm')} 
                    onClose={() => setShowRefuseModal(false)} 
                    onClick={() => handleActionClick('RefuseTicketTransferStep')}
                />
            )}
            <div className='neo-actions-block-container'>
                {title && <h4 className='neo-actions-block-title'>{title}</h4>}
                {subtitle && <p className='neo-actions-block-subtitle'>{subtitle}</p>}
                {config?.message && (
                    <Message 
                        title={config.message.title} 
                        body={config.message.body} 
                    />
                )}
                <div className='neo-actions-block-actions'>
                    {actions?.map((action, index) => {
                        const { icon } = actionMapping[action.type] || {};
                        const label = action.label || action?.config.label || '';
                        const isExcludedType = EXCLUDED_ICON_TYPES.has(action.type);

                        return (
                            <APIAction key={index} name={action.type} actions={actions}>
                                <ActionCard
                                    {...action}
                                    noIconBorder={isExcludedType}
                                    icon={icon}
                                    label={label}
                                    size={isExcludedType ? 'huge' : 'regular'}
                                    disabled={!action.enabled}
                                    onClick={() => handleClick(action)}
                                    className={!isExcludedType ? 'neo-action-with-fill' : ''}
                                />
                            </APIAction>
                        );
                    })}
                </div>
            </div>
        </>
    );
}